<nz-space nzDirection="vertical" style="width: 100%;">
  <nz-space-item>
    <nz-space style="float: right;">
      <nz-space-item>
        <nz-button-group *ngIf="this.reportDetails != null && !this.reportDetails.AutoExportPDF">
          <button nz-button [class]="'pdf-btn-'+ this.reportId" [disabled]="isLoading || isTableLoading" (click)="openExportDrawer('pdf');">
            <i class="fal fa-file-pdf"></i>
            {{'PDF' | locale}}
          </button>
          <button nz-button [class]="'csv-btn-'+ this.reportId" [disabled]="isLoading || isTableLoading" (click)="openExportDrawer('csv');">
            <i class="fal fa-file-csv"></i>
            {{'CSV' | locale}}
          </button>
          <button nz-button [class]="'excel-btn-'+ this.reportId" [disabled]="isLoading || isTableLoading" (click)="export('excel');">
            <i class="fal fa-file-excel"></i>
            {{'Excel' | locale}}
          </button>
          <button nz-button [class]="'pdf-layout-btn-'+ this.reportId" [disabled]="isLoading || isTableLoading" (click)="export('PdfHTML');">
            <i class="fal fa-file-pdf"></i>
            {{'PDF Layout' | locale}}
          </button>
        </nz-button-group>
        <nz-drawer [nzWrapClassName]="'drawer-size-1x'" [nzTitle]="('Export to ' + exportOptions.exportType) | locale"
          [nzPlacement]="'right'" [nzVisible]="exportOptions.visible" (nzOnClose)="exportOptions.visible = false;"
          [nzFooter]="exportDrawerFooter">
          <article nz-typography>
            <p nz-typography>
              {{'Use below options to decide how the exported file will looks like'|locale}}
            </p>
          </article>
          <div style="width: 100%">
            <nz-form-item *ngIf="exportOptions.exportType === 'pdf'">
              <nz-form-label [nzSpan]="16">{{'Logo' | locale}}</nz-form-label>
              <nz-form-control [nzSpan]="8">
                <nz-switch [(ngModel)]="exportOptions.logo" [nzCheckedChildren]="'Include' | locale"
                  [nzUnCheckedChildren]="'Exclude' | locale"></nz-switch>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item *ngIf="exportOptions.exportType === 'pdf'">
              <nz-form-label [nzSpan]="16">{{'Report Description' | locale}}</nz-form-label>
              <nz-form-control [nzSpan]="8">
                <nz-switch [(ngModel)]="exportOptions.description" [nzCheckedChildren]="'Include' | locale"
                  [nzUnCheckedChildren]="'Exclude' | locale"></nz-switch>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item *ngIf="exportOptions.exportType === 'pdf'">
              <nz-form-label [nzSpan]="16">{{'Report Parameters' | locale}}</nz-form-label>
              <nz-form-control [nzSpan]="8">
                <nz-switch [(ngModel)]="exportOptions.parameters" [nzCheckedChildren]="'Include' | locale"
                  [nzUnCheckedChildren]="'Exclude' | locale"></nz-switch>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item *ngIf="exportOptions.exportType === 'csv'">
              <nz-form-label [nzSpan]="16">{{'CSV Delimiter' | locale}}</nz-form-label>
              <nz-form-control [nzSpan]="8">
                <nz-radio-group [(ngModel)]="exportOptions.delimiter">
                  <label nz-radio-button nzValue=";">{{';' | locale}}</label>
                  <label nz-radio-button nzValue=",">{{',' | locale}}</label>
                  <label nz-radio-button nzValue="t">{{'Tab' | locale}}</label>
                </nz-radio-group>
              </nz-form-control>
            </nz-form-item>
          </div>
        </nz-drawer>
        <ng-template #exportDrawerFooter>
          <nz-space>
            <nz-space-item>
              <button nz-button nzType="primary" [nzLoading]="isTableLoading"
                (click)="export(exportOptions.exportType)">
                {{'Export' | locale}}
              </button>
            </nz-space-item>
            <nz-space-item>
              <button nz-button>
                {{'Cancel' | locale}}
              </button>
            </nz-space-item>
          </nz-space>
        </ng-template>
      </nz-space-item>
      <nz-space-item>
        <button nz-button (click)="loadData(false);" [disabled]="isLoading || isTableLoading" style="float: right;">
          <i nz-icon nzType="reload" nzTheme="outline"></i> {{'Refresh'|locale}}
        </button>
      </nz-space-item>
    </nz-space>
  </nz-space-item>
  <nz-space-item>
    <nz-skeleton *ngIf="isLoading">
    </nz-skeleton>
    <ng-container>
      <app-custom-buttons *ngIf="reportButton!= null" [buttons]="reportButton" [forReport]="true"
        [dataSet]="dataTable.dataset" [reportGuid]="guid">
      </app-custom-buttons>
    </ng-container>

    <ng-container *ngIf="reportDetails != null && reportDetails.AutoExportPDF">
      <iframe *ngIf="urlToShowInIframe != ''"
        #pdfAutoExportIframe
        [src]="urlToShowInIframe | safeHtml : 'resourceUrl'"
        width="100%"
        height="600px"
        style="border: none;"
      >
      </iframe>
    </ng-container>
    <ng-container *ngIf="reportDetails != null && !reportDetails.AutoExportPDF">
      <app-table-section #tableSection *ngIf="reportDetails !== undefined"
        [tableCols]="reportDetails.ColumnSettingsParsed" [dataset]="dataTable.dataset" [tableName]="dataTable.name"
        [cellSettings]="[]" [displayFooter]="true" [isTableLoading]="isTableLoading" [serverSide]="true"
        [totalRecords]="totalRecords" (pageIndexChanged)="pageIndexChanged($event);"
        (pageSizeChanged)="pageSizeChanged($event);" (filtersChanged)="filterChanged()">
      </app-table-section>
    </ng-container>

  </nz-space-item>
</nz-space>
